import { register } from '@shopify/theme-sections'
import { tailwindScreens } from '../core/breakpoints-tailwind'

register('featured-collection', {
  onLoad() {
    var breakpoints = {}
    breakpoints[tailwindScreens.md] = {
      slidesPerView: 2.3,
      spaceBetween: 64,
      freeMode: true,
    }

    breakpoints[tailwindScreens.xl] = {
      slidesPerView: 3.3,
      spaceBetween: 80,
      freeMode: true,
    }

    this.swiper = new Swiper(this.container.querySelector('.swiper-container'), {
      roundLengths: true,
      grabCursor: true,
      spaceBetween: 40,
      slidesPerView: 1.3,
      a11y: true,
      keyboard: {
        enabled: true,
        onlyInViewport: false,
      },
      mousewheel: {
        forceToAxis: true,
      },
      breakpoints
    });
  },

  onUnload() {
    this.swiper.destroy()
  }
});
